import { Trans, useLingui } from "@lingui/react/macro";
import { CardGrid, OrganizationCard } from "@op/sf-editor";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/app/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();
  const { sessionData } = Route.useRouteContext();
  const organizations = sessionData?.user.memberships ?? [];

  return (
    <div className="flex h-full w-full max-w-[1280px] flex-col items-start gap-8 px-4 mx-auto mt-12">
      <div className="flex w-full flex-col items-start gap-4">
        <div className="flex flex-col items-start">
          <span className="text-caption font-caption text-subtext-color">
            <Trans>General</Trans>
          </span>
          <span className="text-heading-1 font-heading-1 text-default-font">
            <Trans>Organizations</Trans>
          </span>
        </div>
        <CardGrid>
          {organizations.map((organization) => (
            <Link
              key={organization.slug}
              to="/app/$organizationSlug"
              params={{
                organizationSlug: organization.slug,
              }}
            >
              <OrganizationCard
                label={t`Organization`}
                organizationName={organization.name}
              />
            </Link>
          ))}
        </CardGrid>
      </div>
    </div>
  );
}
